// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__ytmcp"};